class GenerateParserClass {
    $string = null
    $json = null
    $mapped = {}

    constructor(className, classNamespace) {
        this.$string = '<?php\n'
        this.breakline()
        this.addInNewLine(`namespace ${classNamespace}`)
        this.breakline(); this.breakline()

        const parent = classNamespace.includes('Report') ? 'ReportAbstract' : 'OrderAbstract'
        this.addInNewLine(`use Integration\\Domain\\Entities\\Patient;`)
        this.addInNewLine(`use Integration\\Domain\\Services\\Parsers\\Contracts\\${parent}`)
        this.breakline(); this.breakline()
        this.addInNewLine(`class ${className} extends ${parent}`)
        this.addInNewLine(`{`)
    }

    setJson(json) {
        this.$json = json
    }

    generateToOrderCollection() {
        this.addInNewLine(`public function toOrderCollection(string $content): OrderCollection`)
        this.addInNewLine(`{`)
        this.addInNewLine(`$xml = simplexml_load_string($content);`)
        // this.addInNewLine(`foreach ($xml->ct_Pedido_v7 as $pedido) {`)
        // this.addInNewLine(`$this->setPatient($this->createPatient());`)
        // this.addInNewLine(`$this->setPriority($this->Pedido->Prioridade);`)
        // this.addInNewLine(`$this->mapContainers();`)
        // this.addInNewLine(`}`)
        this.breakline()
        this.addInNewLine(`return $this->orderCollection;`)
        this.addInNewLine(`}`)
    }

    extractElements(node, entity, prefix = null) {
        if (!this.$mapped[entity]) {
            this.$mapped[entity] = {}
        }

        node.children.map(c => {
            const Entity = c.field ? c.field.split('.')[0] : null
            const Field = c.field ? c.field.split('.')[1] : null
            // let name = c.type === 'Array' ? `${c.name}[]` : c.name
            let name = c.name
            name = c.isAttribute ? `@${name}` : name
            const prefixed = prefix ? `${prefix}/${name}` : name

            if (Entity && Entity === entity && c.isForeingKey){
                this.$mapped[entity]['fk_'+Field] = prefixed
            }

            if (Entity && Entity === entity && !this.$mapped[entity][Field]){
                this.$mapped[entity][Field] = prefixed
            }

            if (c.children && c.children.length > 0){
                this.extractElements(c, entity, prefixed)
            }
        })
    }

    generateCreateRecipient() {

        this.extractElements(this.$json, 'recipient')

    }

    generateCreateOrder() {

        this.extractElements(this.$json, 'order')

    }

    generateCreateExam() {

        this.extractElements(this.$json, 'exam')

    }

    generateCreatePatient() {

        this.extractElements(this.$json, 'patient')

    }

    getString() {
        return this.$string + '\n}\n'
    }

    add(str) {
        this.$string = this.$string + str
    }

    addInNewLine(str) {
        this.$string = this.$string + '\n' + str
    }

    breakline() {
        this.$string = this.$string + '\n'
    }
}

export default ($className, $classNamespace) => new GenerateParserClass($className, $classNamespace)

// export default new GenerateParserClass()
